import { InputFormatter } from '@/popup/components/shared/Form/FormTypes'

export const hexFormatter: InputFormatter = value =>
  `0x${value.replace('0x', '')}`

export const removeTrailingSlash: InputFormatter = value =>
  value.replace(/\/$/, '')
